module.exports = __webpack_public_path__ + "static/media/Autumn Wind.e590202f.jpg";